/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsHospital from './HospitalsHospital';

/**
 * The SurgeryTypesBody model module.
 * @module model/SurgeryTypesBody
 * @version v0.3
 */
export default class SurgeryTypesBody {
  /**
   * Constructs a new <code>SurgeryTypesBody</code>.
   * @alias module:model/SurgeryTypesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SurgeryTypesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SurgeryTypesBody} obj Optional instance to populate.
   * @return {module:model/SurgeryTypesBody} The populated <code>SurgeryTypesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SurgeryTypesBody();
      if (data.hasOwnProperty('surgery_type'))
        obj.surgeryType = HospitalsHospital.constructFromObject(data['surgery_type']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsHospital} surgeryType
 */
SurgeryTypesBody.prototype.surgeryType = undefined;

